module.exports = __webpack_public_path__ + "static/media/awslogo.88571218.png";